/* eslint-disable camelcase */
import { VenueInfoInterface } from '@interfaces/venue.interface';

import { MatchFaceoffs } from '@interfaces/faceoffs.interface';

import { MatchShotZones } from '@interfaces/shot-zones.interface';

import { Score } from './score.interface';
import { TennisRankingInterface } from './tennis-rankings.interface';
import { BetsInterface } from './bets-market.interface';

export enum MatchState {
    BEFORE = 'before',
    AFTER = 'after',
    INPLAY = 'inplay-live',
    CANCELED = 'cancelled',
    INPLAYPAUSE = 'inplay-pause',
}

export enum CodeState {
    AP = 'ap',
    AET = 'aet',
    NOTSTARTED = 'not_started',
    ENDED = 'ended',
    WALKOVER = 'walkover',
    RETIRED = 'retired',
    POSTPONED = 'postponed',
    PENALTIES = 'penalties',
}

export enum RefereeType {
    BASIC = 'referee',
    MAIN = 'main_referee',
    FIRST_ASSISTANT = 'first_assistant_referee',
    SECOND_ASSISTANT = 'second_assistant_referee',
    VIDEO_ASSISTANT = 'video_assistant_referee',
    FOURTH_OFFICIAL = 'fourth_official',

    UMPIRE = 'umpire',
    DOWN_JUDGE = 'downjudge',
    LINE_JUDGE = 'linejudge',
    FIELD_JUDGE = 'fieldjudge',
    SIDE_JUDGE = 'sidejudge',
    BACK_JUDGE = 'backjudge',
    REPLAY_OFFICIAL = 'replayofficial',

    HEAD_OFFICIAL = 'head_official',
    OFFICIAL = 'official',
}

export enum HockeyPosition {
    GOALIE = 'goalie',
    LEFTBACK = 'left back',
    RIGHTBACK = 'right back',
    LEFTWINK = 'left wink',
    CENTER = 'center',
    RIGHTWINK = 'right wink',
}

export enum Periods {
    AP = 'ap',
    AET = 'aet',
    PENALTIES = 'penalties',
    PERIOD1 = 'period_1',
    PERIOD2 = 'period_2',
    PERIOD3 = 'period_2',
    PERIOD4 = 'period_2',
    PERIOD5 = 'period_2',
    PERIOD6 = 'period_2',
    PERIOD7 = 'period_2',
    PERIOD8 = 'period_2',
    PERIOD9 = 'period_2',
    PERIOD10 = 'period_2',
    PERIOD11 = 'period_2',
    PERIOD12 = 'period_2',
    PERIOD13 = 'period_2',
    PERIOD14 = 'period_2',
    OVERTIME = 'overtime',
    INTERRUPTED = 'interrupted',
}

export interface StatsTournamentStatsItem {
    type: string;
    value: string | null;
}

export interface StatsTournamentStats {
    readonly goals_for_team: StatsTournamentStatsItem | null;
    readonly goals_in_tournament: StatsTournamentStatsItem | null;
    readonly assists_for_team: StatsTournamentStatsItem | null;
    readonly matches_played_for_team: StatsTournamentStatsItem | null;
    readonly minutes_played: StatsTournamentStatsItem | null;
    readonly red_cards_for_team: StatsTournamentStatsItem | null;
    readonly yellow_cards_for_team: StatsTournamentStatsItem | null;
    readonly assists: StatsTournamentStatsItem | null;
    readonly goals_scored: StatsTournamentStatsItem | null;
    readonly matches_played: StatsTournamentStatsItem | null;
    readonly red_cards: StatsTournamentStatsItem | null;
    readonly yellow_cards: StatsTournamentStatsItem | null;

    // NFL
    readonly defense_tackles: StatsTournamentStatsItem | null;
    readonly defense_assists: StatsTournamentStatsItem | null;
    readonly defense_sacks: StatsTournamentStatsItem | null;
    readonly defense_interceptions: StatsTournamentStatsItem | null;
    readonly defense_forced_fumbles: StatsTournamentStatsItem | null;
    readonly passing_completions: StatsTournamentStatsItem | null;
    readonly passing_attempts: StatsTournamentStatsItem | null;
    readonly passing_yards: StatsTournamentStatsItem | null;
    readonly passing_touchdowns: StatsTournamentStatsItem | null;
    readonly passing_interceptions: StatsTournamentStatsItem | null;
    readonly rushing_attempts: StatsTournamentStatsItem | null;
    readonly rushing_yards: StatsTournamentStatsItem | null;
    readonly rushing_touchdowns: StatsTournamentStatsItem | null;
    readonly rushing_longest: StatsTournamentStatsItem | null;
    readonly receiving_targets: StatsTournamentStatsItem | null;
    readonly receiving_receptions: StatsTournamentStatsItem | null;
    readonly receiving_yards: StatsTournamentStatsItem | null;
    readonly receiving_touchdowns: StatsTournamentStatsItem | null;
    readonly receiving_longest: StatsTournamentStatsItem | null;
    readonly field_goals_made: StatsTournamentStatsItem | null;
    readonly field_goals_attempts: StatsTournamentStatsItem | null;
    readonly field_goals_longest: StatsTournamentStatsItem | null;
    readonly extra_points_made: StatsTournamentStatsItem | null;
    readonly extra_points_attempts: StatsTournamentStatsItem | null;
    readonly punt_returns_returns: StatsTournamentStatsItem | null;
    readonly punts_attempts: StatsTournamentStatsItem | null;
    readonly punts_avg_yards: StatsTournamentStatsItem | null;
    readonly punts_inside_20: StatsTournamentStatsItem | null;
    readonly punts_longest: StatsTournamentStatsItem | null;
    readonly kick_returns_returns: StatsTournamentStatsItem | null;
    readonly kick_returns_avg_yards: StatsTournamentStatsItem | null;
    readonly kick_returns_longest: StatsTournamentStatsItem | null;
    readonly kick_returns_touchdowns: StatsTournamentStatsItem | null;
    readonly punt_returns_avg_yards: StatsTournamentStatsItem | null;
    readonly punt_returns_longest: StatsTournamentStatsItem | null;

    // NBA
    readonly average_points: StatsTournamentStatsItem | null;
    readonly average_points_in_paint: StatsTournamentStatsItem | null;
    readonly average_points_in_paint_att: StatsTournamentStatsItem | null;
    readonly average_points_in_paint_made: StatsTournamentStatsItem | null;
    readonly average_points_off_turnovers: StatsTournamentStatsItem | null;
    readonly average_second_chance_pts: StatsTournamentStatsItem | null;
    readonly average_fast_break_pts: StatsTournamentStatsItem | null;
    readonly total_points: StatsTournamentStatsItem | null;
    readonly total_points_in_paint: StatsTournamentStatsItem | null;
    readonly total_points_in_paint_att: StatsTournamentStatsItem | null;
    readonly total_points_in_paint_made: StatsTournamentStatsItem | null;
    readonly total_points_in_paint_pct: StatsTournamentStatsItem | null;
    readonly total_points_off_turnovers: StatsTournamentStatsItem | null;
    readonly total_second_chance_pts: StatsTournamentStatsItem | null;
    readonly total_fast_break_pts: StatsTournamentStatsItem | null;
    readonly average_rebounds: StatsTournamentStatsItem | null;
    readonly average_def_rebounds: StatsTournamentStatsItem | null;
    readonly average_off_rebounds: StatsTournamentStatsItem | null;
    readonly total_rebounds: StatsTournamentStatsItem | null;
    readonly total_defensive_rebounds: StatsTournamentStatsItem | null;
    readonly total_offensive_rebounds: StatsTournamentStatsItem | null;
    readonly average_assists: StatsTournamentStatsItem | null;
    readonly average_turnovers: StatsTournamentStatsItem | null;
    readonly total_assists: StatsTournamentStatsItem | null;
    readonly total_turnovers: StatsTournamentStatsItem | null;
    readonly total_assists_turnover_ratio: StatsTournamentStatsItem | null;
    readonly total_usage_pct: StatsTournamentStatsItem | null;
    readonly average_blocks: StatsTournamentStatsItem | null;
    readonly average_blocked_att: StatsTournamentStatsItem | null;
    readonly average_steals: StatsTournamentStatsItem | null;
    readonly total_blocks: StatsTournamentStatsItem | null;
    readonly total_blocked_att: StatsTournamentStatsItem | null;
    readonly total_steals: StatsTournamentStatsItem | null;
    readonly average_field_goals_att: StatsTournamentStatsItem | null;
    readonly average_field_goals_made: StatsTournamentStatsItem | null;
    readonly average_two_points_att: StatsTournamentStatsItem | null;
    readonly average_two_points_made: StatsTournamentStatsItem | null;
    readonly average_three_points_att: StatsTournamentStatsItem | null;
    readonly average_three_points_made: StatsTournamentStatsItem | null;
    readonly average_free_throws_att: StatsTournamentStatsItem | null;
    readonly average_free_throws_made: StatsTournamentStatsItem | null;
    readonly average_true_shooting_att: StatsTournamentStatsItem | null;
    readonly total_field_goals_att: StatsTournamentStatsItem | null;
    readonly total_field_goals_made: StatsTournamentStatsItem | null;
    readonly total_field_goals_pct: StatsTournamentStatsItem | null;
    readonly total_two_points_att: StatsTournamentStatsItem | null;
    readonly total_two_points_made: StatsTournamentStatsItem | null;
    readonly total_two_points_pct: StatsTournamentStatsItem | null;
    readonly total_three_points_att: StatsTournamentStatsItem | null;
    readonly total_three_points_made: StatsTournamentStatsItem | null;
    readonly total_three_points_pct: StatsTournamentStatsItem | null;
    readonly total_free_throws_att: StatsTournamentStatsItem | null;
    readonly total_free_throws_made: StatsTournamentStatsItem | null;
    readonly total_free_throws_pct: StatsTournamentStatsItem | null;
    readonly total_true_shooting_att: StatsTournamentStatsItem | null;
    readonly total_true_shooting_pct: StatsTournamentStatsItem | null;
    readonly total_effective_fg_pct: StatsTournamentStatsItem | null;

    // MLB
    readonly hitting_overall_wrc_plus: StatsTournamentStatsItem | null;
    readonly hitting_overall_ops: StatsTournamentStatsItem | null;
    readonly hitting_overall_obp: StatsTournamentStatsItem | null;
    readonly hitting_overall_slg: StatsTournamentStatsItem | null;
    readonly hitting_overall_woba: StatsTournamentStatsItem | null;
    readonly hitting_overall_iso: StatsTournamentStatsItem | null;
    readonly hitting_overall_bbpa: StatsTournamentStatsItem | null;
    readonly hitting_overall_pitches_ktotal: StatsTournamentStatsItem | null;
    readonly hitting_overall_babip: StatsTournamentStatsItem | null;
    readonly pitching_overall_fip: StatsTournamentStatsItem | null;
    readonly pitching_overall_xfip: StatsTournamentStatsItem | null;
    readonly pitching_overall_whip: StatsTournamentStatsItem | null;
    readonly pitching_overall_kbb: StatsTournamentStatsItem | null;
    readonly pitching_overall_k9: StatsTournamentStatsItem | null;
    readonly pitching_overall_onbase_h9: StatsTournamentStatsItem | null;
    readonly pitching_overall_obp: StatsTournamentStatsItem | null;
    readonly pitching_overall_babip: StatsTournamentStatsItem | null;
    readonly fielding_overall_fpct: StatsTournamentStatsItem | null;
    readonly fielding_overall_error: StatsTournamentStatsItem | null;
    readonly fielding_overall_rf: StatsTournamentStatsItem | null;
    readonly fielding_overall_dp: StatsTournamentStatsItem | null;
    readonly fielding_overall_po: StatsTournamentStatsItem | null;
    readonly fielding_overall_a: StatsTournamentStatsItem | null;
    readonly fielding_overall_tc: StatsTournamentStatsItem | null;
    readonly fielding_overall_steal_caught: StatsTournamentStatsItem | null;
    readonly fielding_overall_steal_stolen: StatsTournamentStatsItem | null;
    readonly fielding_overall_pb: StatsTournamentStatsItem | null;
}

export interface StatsTournamentStatsSubtournament {
    subtournament_id: number;
    subtournament_name: string;
    subtournament_type: string | null;
    subtournament_order?: number;
    data: StatsTournamentStats;
}

export type StatsTournamentStatsKey = keyof StatsTournamentStats;

export interface StatsTournamentSeason {
    season_id: number;
    season_name: string;
}

export interface StatsTournament {
    readonly tournament_id: number;
    readonly tournament_name: string;
    readonly tournamentOrder: number;
    readonly has_subtournaments: boolean;
    readonly seasons: StatsTournamentSeason[];
    readonly selected_season: number;
    subtournaments?: StatsTournamentStatsSubtournament[];
    data?: StatsTournamentStats;
}

export enum MatchResult {
    WIN = 'win',
    LOSE = 'lose',
    DRAW = 'draw',
}

export enum Winner {
    NOT_SET = 0,
    HOME = 1,
    AWAY = 2,
}

export type PeriodKeys =
    | 'score_period_1'
    | 'score_period_2'
    | 'score_period_3'
    | 'score_period_4'
    | 'score_normal_time';

export type MatchDetailDisplayMode =
    | 'all'
    | 'table'
    | 'h2h'
    | 'overview'
    | 'player-ratings'
    | 'statistics'
    | 'statistics-extended'
    | 'tracker'
    | 'video'
    | 'cuptree'
    | 'lineup'
    | 'lineup-opta'
    | 'news';

export type H2HlDisplayMode = 'widget';

export type PlayerStatsInfo = keyof StatsTournament;

/**
 *  Match data interfaces
 *  @author Livescore <live@score-stats.com>
 *  @copyright 2019 livescore
 */

export interface MatchCommentary {
    source_id: number;
    time: number;
    message: string;
}

export interface Probability {
    name: string;
    outcomes: { name: string; probability: number }[];
}

export type TimelineType =
    | 'deciding_team'
    | 'match_called'
    | 'period_score'
    | 'match_ended'
    | 'score_change'
    | 'point'
    | 'match_started'
    | 'period_start'
    | 'first_serve';
type TennisResultIndex = 'server' | 'receiver';
type TennisResultIndex2 = 'won' | 'lost';

export type TennisResult = `${TennisResultIndex}_${TennisResultIndex2}` | 'double_fault' | 'ace';

export type TennisMapFce = Record<string, Record<string, any>[] | boolean>;
export type DartsMapFce = Record<string, any>;
export type DefaultMapFce = Record<string, Record<string, any>[]>;
export type AmericanFootballMapFce = Record<string, Record<string, any>[]>;
export type BasketballMapFce = Record<string, Record<string, any>[]>;
export type BaseballMlbMapFce = Record<string, Record<string, any>[]>;

export interface PlayerStatisticsGroupStatistics {
    name: string;
}

export interface PlayerStatisticsGroup {
    group: {
        name: string;
    };
    statistics: PlayerStatisticsGroupStatistics[];
}

export interface CoinTossParticipant {
    outcome: 'lost' | 'won';
    decision: 'receive' | 'defer' | 'kick';
    direction: 'north' | 'south' | 'east' | 'west';
}

export interface CoinToss {
    home: CoinTossParticipant;
    away: CoinTossParticipant;
    quarter: number;
}

export interface PlayerStatistics {
    home: { [key: number]: { player: { name: string; id: number }; statistics: Record<string, number | string> } };
    away: { [key: number]: { player: { name: string; id: number }; statistics: Record<string, number | string> } };
    groups: PlayerStatisticsGroup[];
}

export interface PossibleGoal {
    id: number;
    type: 'possible_goal';
    time: string;
}

export interface PeriodStatistics {
    barons: { home: string; away: string };
    dragons: { home: string; away: string };
    gold: { home: string; away: string };
    inhibitors: { home: string; away: string };
    kills: { home: string; away: string };
    towers: { home: string; away: string };
}

export interface Timeline {
    readonly id: number | null;
    readonly source_id?: number | null;
    readonly away_score: number | null;
    readonly break_name: string | null;
    competitor: 'home' | 'away' | null;
    readonly first_serve_fault: boolean | null;
    readonly home_score: number | null;
    homeScoreDiff?: number | null;
    awayScoreDiff?: number | null;
    readonly last_point_result: string | null;
    readonly match_clock: string | null;
    readonly away_match_timescore: string | null;
    readonly period: number | null;
    period_name: string | null;
    readonly match_time?: string;
    frame_number: number;
    frame_score: string;
    frameScoreHome?: number;
    frameScoreAway?: number;
    readonly players: any[] | null;
    mainPlayers: Record<string, any>[];
    assistsPlayers: Record<string, any>[];
    suspensionPlayers: Record<string, any>[];
    fouledPlayers: Record<string, any>[];
    substitutionPlayers: { in: string[]; out: string[] };
    readonly points: any | null;
    readonly reason: string | null;
    readonly result: TennisResult | null;
    readonly server: 'home' | 'away' | null;
    readonly serving: 'home' | 'away' | null;
    readonly suspension_minutes: number | null;
    readonly tie_break: boolean | null;
    readonly number_of_red_balls?: number;
    readonly time: string | null;
    type: TimelineType | string | null;
    readonly x: number | null;
    readonly y: number | null;
    readonly inning?: number;
    readonly ball_number?: number;
    readonly over_number?: number;
}

export interface MatchSimple {
    readonly id: number;
    readonly date: string;
    readonly home_team: string;
    readonly away_team: string;
    readonly home_image: string;
    readonly away_image: string;
    readonly tournament: string;
    readonly flag?: string;
    readonly score: Score;
    readonly badge: string;
    readonly badge_class: string;
    readonly code_state: string;
    readonly match_state: string;
}

export interface Channel {
    name: string;
    readonly url: string;
    readonly country: { flag: string | null; name: string | null; id: number };
}

export interface MatchMeta {
    tracker?: number;
    attendance?: number;
    referee?: string;
    referees?: { name: string; type: RefereeType; nationality: string; iso: string }[];
    referees_text?: string | null;
    weather?: string;
}

export interface Phrases {
    id: number;
    match_action_id?: number;
    time: string | null;
    text: string;
    type: { id: number; description: string };
    event_type: { id: number; name: string; description: string };
}

export interface MatchActionScoreItem {
    type: 'GOAL';
    team: 'home' | 'Away';
    state: Periods;
    time: string;
    addedTime: string;
    image?: string;
    name?: string;
    subs_name: string[];
    points?: number;
    actual_score?: string;
}

export interface MatchActionsScore {
    period: { name: string };
    actions: MatchActionScoreItem[];
}

export interface MatchActionItem {
    state: Periods;
    time: string;
    image?: string;
    name?: string;
    subs_name: string[];
    points?: number;
    actual_score?: string;
}

export interface MatchActions {
    period: { name: string };
    actions: MatchActionItem[];
}

export type TotalStatistics = {
    home: Record<string, number | string>;
    away: Record<string, number | string>;
    context?: Record<string, any>;
};

export type ParticipantStatisticsValue = {
    home: number | string;
    away: number | string;
    context?: Record<string, any>;
};

export type ParticipantStatistics = {
    [statType: string]: ParticipantStatisticsValue;
};

export interface H2H {
    limit: number;
    sportName?: string;
    total: {
        home_team: MatchSimple[];
        away_team: MatchSimple[];
        h2h: MatchSimple[];
    };
    home: { home_team: MatchSimple[]; h2h: MatchSimple[] };
    away: { away_team: MatchSimple[]; h2h: MatchSimple[] };
}

export interface Jersey {
    base: string;
    horizontalStripes: boolean;
    number: string;
    shirtType: string;
    sleeve: string;
    sleeveDetail: string;
    split: boolean;
    splitColor: string;
    squaresColor: string;
    stripesColor: string;
    horizontalStripesColor: string;
    squares: boolean;
    stripes: boolean;
    jerseyType: 'away' | 'home' | 'goalkeeper' | 'third' | 'primary' | 'secondary';
}

export interface TennisTournamentInfo {
    name: string;
    short_name: string;
}

export interface Team {
    id: number;
    type: string;
    image?: string;
    countryImage?: string | null;
    name: string;
    name_short?: string;
    alias: string | null;
    scratch: boolean;
    red_cards: number;
    formation?: string;
    cuptree_is_final?: boolean;
    table_position?: number;
    seed?: number;
    bracket_number?: number;
    tennis_tournament_info?: TennisTournamentInfo;
    jerseys?: Jersey[];
    seasonStats?: Record<string, number | string>;
    readonly lineup_string?: string;
    readonly bench_string?: string;
}

export type PlayerInfo = 'form' | 'age' | 'height' | 'nationality';

export interface Player {
    id: number;
    position: string;
    number: string | null;
    flag: string;
    name: string;
    name_short: string;
    age: number;
    height: number;
    injury: boolean;
    start_lineup: boolean;
    goals?: number;
    red_card?: number;
    yellow_card?: number;
    yellow_red_card?: number;
    assists?: number;
    lineupPosition?: number | string;
    matchPosition?: number | string;
    readonly formation?: string;
    readonly lineupFormation?: string;
    sort?: number;
    substitute: number;
    statistics?: any;
    team: string;
    role?: string;
    photo?: string;
    missing_reason?: string;
    missing_registered?: string;
    missing_expected_back?: string;
    missing_global?: boolean;
    statsTournament?: StatsTournament[];
    participants?: {
        id: number;
        name: string;
        name_short: string | null;
        alias: string | null;
        image: string | null;
    }[];
}

export type PlayerExtend = Player & {
    home?: string;
    away?: string;
    betradar_major_league?: boolean;
};

export interface News {
    id: string;
    title: string;
    content: string;
    ext_link: string;
    datetime: string;
    image_original: string;
    image_small: string;
}

export interface SportEventCondition {
    weather_info: {
        rain_conditions: 'no_rain' | 'expected_soon' | 'showers' | 'rain' | 'heavy_rain' | 'unknown';
        sky_conditions: 'clear' | 'partly_cloudy' | 'cloudy' | 'overcast' | 'unknown';
        temperature_range: 'very_hot' | 'hot' | 'warm' | 'mild' | 'cold' | 'very_cold' | 'unknown';
        wind_conditions: 'no_wind' | 'breeze' | 'windy' | 'gale' | 'unknown';
    };
    pitch_info: {
        boundary_position: 'in' | 'normal' | 'unknown';
        grass_cover: 'barren' | 'normal' | 'green' | 'unknown';
        pitch_moisture: 'very_dry' | 'dry' | 'normal' | 'moist' | 'unknown';
        pitch_quality: 'normal' | 'delayed' | 'deteriorating' | 'slow' | 'low' | 'unknown';
    };
    outfield_info: {
        outfield_conditions: 'slow' | 'normal' | 'fast';
    };
    day_night: 'day' | 'night';
    type: 'test' | 'odi' | 't10' | 't20i' | 'first_class' | 'list_a' | 't20';
}

export interface MatchBroadcast {
    network: string;
}

export enum WeatherFormatEnum {
    OPEN_WEATHER = 'open_weather',
    BETRADAR = 'betradar',
}

export interface BetradarWeather {
    condition: string;
    humidity: number;
    temp: number;
    wind: {
        speed: number;
        direction: string;
    };
}

export interface Participant {
    id: number;
    name: string;
    name_short: string | null;
    alias: string;
    image: string | null;
}

export interface ParticipantWithQualifier extends Participant {
    qualifier: 'home' | 'away';
}

export interface PremiumTimelineEvent {
    id: number;
    period_type: string;
    period_number: number;
    start_situation: {
        clock: string;
        possession: {
            participant: Participant;
        };
        down: number;
        yfd: number;
        location: {
            participant: Participant;
            yardline: number;
        };
    };
    description: string;
}

export interface PremiumTimeline {
    id: number;
    end_reason: string;
    duration: string;
    gain: number;
    play_count: number;
    scoring_drive: boolean;
    home_points: number;
    away_points: number;
    home_score: number;
    away_score: number;
    offensive_participant: ParticipantWithQualifier;
    defensive_participant: ParticipantWithQualifier;
    events: PremiumTimelineEvent[];
}

export interface PremiumTimelinePeriod {
    period_type: string;
    period_number: number;
    timelines: PremiumTimeline[];
}

export interface ProbablePitcher {
    team: 'home' | 'away';
    player: {
        id: number;
        name: string;
        image: string | null;
    };
}

export interface MatchData<T = []> {
    id: number;
    category_id: number;
    category_name: string;
    image: string;
    sport_code_name: string;
    sport_id: number;
    sub_tournament_id: number;
    tournament: {
        id: number;
        betradar_major_league: boolean;
        country: {
            name: string;
            iso: string;
            iso3: string;
        } | null;
    };
    tournament_id: number; // @deprecated
    season_id?: number;
    start_date: string;
    duration: string | null;
    minute?: string | null;
    possession: 1 | 2 | null;
    added_time?: number;
    period_length: number;
    isLive: boolean;
    winner?: number;
    aggregate_winner?: number;
    display_time: boolean;
    last_time_update?: number;
    display_period_time?: boolean;
    last_update?: number;
    is_favorited?: boolean;
    code_state: CodeState | null;
    match_state: MatchState;
    hasTable: boolean;
    hasCupTree: boolean;
    liveTable?: boolean;
    hasPlayerStats?: boolean;
    metainfo?: MatchMeta;
    venue?: VenueInfoInterface;
    match_actions?: MatchActions[];
    match_actions_score?: MatchActionsScore[];
    h2h?: H2H;
    participants: T extends Team ? T : Team[];
    tracker?: number | null;
    round: number;
    round_name: string;
    info: string;
    participantStatistics: ParticipantStatistics;
    periodStatistics?: ParticipantStatistics[];
    playerStatistics: PlayerStatistics;
    score: Score;
    players?: Player[];
    tennis_rankings?: TennisRankingInterface[];
    comments?: string[];
    funfacts?: string[];
    tournament_name: string;
    sub_tournament_name: string;
    odds?: BetsInterface;
    twitch_channel?: string;
    twitch_video?: string | number;
    youtube_video?: string;
    youtube_preview?: string | null;
    nhl_video?: string;
    isport_video?: string;
    vimeo_video?: string;
    tvcom_video?: string;
    phrases: Phrases[];
    news?: News[];
    possibleGoal?: PossibleGoal;
    live_timelines?: Timeline[];
    has_premium_timelines: boolean;
    premium_timelines: PremiumTimelinePeriod[] | null;
    channels?: Channel[];
    weather_format: WeatherFormatEnum;
    weather?: Record<string, any> | BetradarWeather | null;
    stoppage_time_announced: string | null;
    opta_competition: string | number | null;
    opta_season: string | number | null;
    opta_match: string | number | null;
    probabilities: Probability[] | null;
    day_night: 'd' | 'n' | null;
    probable_pitcher?: ProbablePitcher | null;
    match_commentaries: MatchCommentary[];
    sport_event_conditions: SportEventCondition;
    innings?: Record<string, any>[];
    toss_won_by?: number;
    toss_decision?: 'bowl' | 'bat';
    broadcast: MatchBroadcast | MatchBroadcast[] | null;
    coin_toss: CoinToss[] | null;
    has_faceoffs: boolean;
    faceoffs: MatchFaceoffs | null;
    has_shot_zones: boolean;
    shot_zones: MatchShotZones;
}
